import Button from 'app/components/button';
import DraggableTable from 'app/components/DraggableTable';
import PageLoader from 'app/components/PageLoader';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import { BannerHeader } from 'app/constants/table-header-constants';
import useMallBanner from './useMallBanner';
import Dropdown from 'app/components/Dropdown';
import AddUser from 'assets/images/ic-users-add.svg';
import { useState, useEffect, useMemo } from 'react';

const MallBanner = () => {
  const {
    handleSelect,
    pageLoading,
    mallList,
    navigate,
    bannerList,
    handleDelete,
    bannerOrder,
    mallId,
    analyticsAction,
  } = useMallBanner();

  console.log('bannerList', bannerList);
  

  // ---- state for load more ----
  const [visibleCount, setVisibleCount] = useState(5);

  console.log('visibleCount', visibleCount);

  // Reset when the selected mall changes. Deliberately not keyed on bannerList
  // — reordering rewrites that array, which would collapse an expanded list
  // back to 5 rows mid-drag.
  useEffect(() => {
    setVisibleCount(5);
  }, [mallId]);

  const menuActionObj = (data) => {
    navigate(`/mall-banner/edit/:${data.id}`, {
      state: {
        ...data,
        mall_id: data.mall_id || mallId,
      },
    });
  };

  const sectionObj = {
    sectionTitle: 'Breathfree Service Bottom Navigation',
  };
  // Memoized so DraggableTable isn't handed a new array identity on every
  // render, which would reset its in-progress row order.
  const displayedData = useMemo(
    () => bannerList?.slice(0, visibleCount) || [],
    [bannerList, visibleCount]
  );
  
  return (
    <>
      <div className="cms-content__container">
        <h4>Mall Banner Management</h4>
        <div className="content-container__actionBox">
          <div className="content-container__filterSearch">
            <Dropdown
              id={'mallId'}
              label="Select Mall*"
              name="mallId"
              options={mallList}
              placeholder="Select Mall "
              value={mallId && mallId}
              handleChange={handleSelect}
            />
          </div>
          <Button
            onClick={() =>
              navigate(`${APP_CONSTANTS.CREATE_MALL_BANNER}`, {
                state: { mall_id: mallId },
              })
            }
            className="content-container__filter-btn"
          >
            <img
              src={AddUser}
              alt="Add user"
              width="25"
              height="25"
              className="mr-5"
            />
            {`${APP_CONSTANTS.CREATE_MALL_BANNER_TAG}`}
          </Button>
        </div>
        {bannerList && bannerList.length > 0 && (
          <>
            <label className="tool-tip">Banner List</label>
            <div className="table-wrapper">
              <DraggableTable
                sectionObj={sectionObj}
                tableHeader={BannerHeader}
                menuAction={menuActionObj}
                handleDelete={handleDelete}
                HomePageOrder={bannerOrder}
                getData={displayedData}
                hasPagination={false}
                analyticsAction={analyticsAction}
              />
            </div>

            {/* ---- View More / Less ---- */}
            <div className="text-center mt-3">
              {bannerList.length > 5 && (
                <Button
                  onClick={() =>
                    visibleCount >= bannerList.length
                      ? setVisibleCount(5) // reset to first 5
                      : setVisibleCount((prev) => prev + 5) // load more
                  }
                >
                  {visibleCount >= bannerList.length ? "View Less" : "View More"}
                </Button>
              )}
            </div>

          </>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default MallBanner;